import { PackingCategoryEnum } from "@gtpl/shared-models/common-models"
import { CompanyTypeEnum, DisplayNameEnum } from "../.."


export class BankDetailsRequest{
    id:number
    bankName:string
    bankAcc:string
    swiftCode:string
    ifscCode:string
    branchName:string
    bankAddress:string
    company:CompanyTypeEnum
    createdUser:string
    updatedUser:string
    isActive:boolean
    versionFlag:number
    createdAt:Date
    displayName?:DisplayNameEnum
    
    constructor(
        id:number,
        bankName:string,
        bankAcc:string,
        swiftCode:string,
        ifscCode:string,
        branchName:string,
        bankAddress:string,
        company:CompanyTypeEnum,
        createdUser:string,
        updatedUser:string,
        isActive:boolean,
        versionFlag:number,
        createdAt:Date,
        displayName?:DisplayNameEnum

    ){
       this.id = id
       this.createdUser = createdUser
       this.updatedUser = updatedUser
       this.isActive = isActive
       this.versionFlag = versionFlag
       this.createdAt = createdAt
      this.bankAcc = bankAcc
      this.bankAddress = bankAddress
      this.bankName = bankName
      this.branchName = branchName
      this.company = company
      this.ifscCode = ifscCode
      this.swiftCode = swiftCode
      this.displayName = displayName
    }
}